import type {
	SubjectFieldValuePayload,
	SubjectValuesPayload,
} from '@Application/Subjects/Actions/subjectFetched';
import type SubjectFieldDefinitionView from '@UI/Store/SubjectTypes/Views/SubjectFieldDefinitionView';

/**
 * The sheet values of a dossier. The server may also send values of archived fields: they are only
 * reachable through the definition of an active field.
 */
class SubjectValuesView {
	private readonly entries: SubjectValuesPayload;

	constructor(payload: SubjectValuesPayload = {}) {
		this.entries = Object.freeze({ ...payload });

		Object.freeze(this);
	}

	/** `null` when the field has no value yet. */
	valueOf(definition: SubjectFieldDefinitionView): SubjectFieldValuePayload | null {
		return Object.hasOwn(this.entries, definition.key) ? (this.entries[definition.key] ?? null) : null;
	}
}

export default SubjectValuesView;
